import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, Observable } from 'rxjs';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { OrderService } from 'src/app/services/order.service';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {

  constructor(private cartService: CartService,private scriptLoader: ScriptLoaderService, private authService: AuthServiceService , private wishlist : WishlistService,private router: Router, private orderservice : OrderService, private cdr: ChangeDetectorRef,) { }
  scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/nouislider.min.js',
    'assets/js/shop.js',
    'assets/js/main.js'

  ];
  cartItems: any[] = [];
  total: number = 0;
  subtotal: number = 0;
  discountedSubtotal: number = 0;
  couponCode: string = '';
  couponValue: number | null = null;
  isModalOpen: boolean = false;
  itemToRemove: number | null = null;
  user: any = {};
  errorMessage: string = '';
 wishlistCount: number = 0;
  cartCount: number = 0;

  commandeObject: any = {};
  commandeFinale:any={}
  confirmationMessage: string = '';

  ListArticles: any;
  selectedPaymentMethod: string = 'cash';

  articleLabelsCache: { [key: number]: string } = {};
  userLogin = {
    username: '',
    password: ''
  };
  showLoading = false;

  rememberMe: boolean = false;

  showPassword: boolean = false;

  errors: { [key: string]: string } = {};

  ngOnInit(): void {
    this.scriptLoader.loadScripts(this.scripts);
     this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });
      this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });
    this.loadCartItems();
  }
  quantity:number =1;
  incrementQuantity(itemId: number): void {
    this.cartService.incrementQuantity(itemId);
    this.loadCartItems();
  }

  decrementQuantity(itemId: number): void {
    this.cartService.decrementQuantity(itemId);
    this.loadCartItems();
  }
  getCartTotal(): number {
    const total = this.cartItems.reduce((total, item) => {
      const price = item.promo !== 0 ? item.prix_final : item.prix_ttc;
      const itemTotal = price * item.quantity;
      return total + itemTotal;
    }, 0);
    return total;
  }
 goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  getRemainingForFreeShipping(): number {
    const threshold = 99;
    const currentTotal = this.getCartTotal();
    return Math.max(0, threshold - currentTotal);
  }
  loadCartItems(): void {
    this.cartItems = this.cartService.getCartItems();

  }
  goToCheckout() {
    this.router.navigate(['/checkout']);
  }
  // Met à jour le prix total
  updateTotalPrice(article: any): void {
    article.totalPrice = this.quantity * article.prix_ttc;
  }

  removeFromCart(itemId: number): void {
    this.cartService.removeFromCart(itemId);
    this.loadCartItems();


  }
  getCouponValue(codePromo: string): Observable<number> {
      return this.orderservice.getpromobycodepromo(codePromo).pipe(
        map(response => {
          if (response && response.valeur) {
            this.couponValue = response.valeur;
            localStorage.setItem('couponCode', this.couponCode);
            localStorage.setItem('couponValue', response.valeur.toString());
            return response.valeur;
          } else {
            throw new Error('Coupon not found');
          }
        }),
        catchError(error => {
          console.error('Error fetching coupon value:', error);
          throw error;
        })
      );
    }
    fetchCouponValue() {
      console.log('Méthode fetchCouponValue appelée');
      if (!this.couponCode.trim()) {
        this.errorMessage = 'Veuillez entrer un code promo.';
        this.cdr.detectChanges(); // Force la détection des changements
        return;
      }

      this.cartService.getPromoDetails(this.couponCode).subscribe(
        (promo) => {
          console.log('Réponse API :', promo);
          const today = new Date();
          const endDate = new Date(promo.date_fin);

          console.log('Date actuelle :', today);
          console.log('Date de fin :', endDate);

          if (today > endDate) {
            console.log('Code promo expiré par la date');
            this.errorMessage = 'Ce code promo est expiré (date dépassée).';
            this.couponValue = null;
          } else if (promo.commandes.length >= promo.max_utilisations) {
            console.log('Code promo expiré par le nombre d\'utilisations');
            this.errorMessage = 'Ce code promo a atteint son nombre maximum d\'utilisations.';
            this.couponValue = null;
          } else {
            console.log('Code promo valide');
            this.errorMessage = '';
            this.couponValue = promo.valeur;
            this.calculateSubtotals();
          }
        },
        (error) => {
          console.error('Erreur API :', error);
          this.errorMessage = 'Une erreur est survenue lors de la validation du code promo.';
          this.couponValue = null;
          this.cdr.detectChanges(); // Force la mise à jour
        }
      );
    }
    calculateSubtotals(): void {
      this.cartItems = this.cartItems.map(item => ({
        ...item,
        subtotal: item.promo !== 0 && item.prix_final
          ? parseFloat((item.prix_final * item.quantity).toFixed(3))
          : item.prix_ttc
            ? parseFloat((item.prix_ttc * item.quantity).toFixed(3))
            : parseFloat((item.prix * item.quantity).toFixed(2))
      }));
      const initialSubtotal = this.getTotalSubtotal();

      if (this.couponValue) {
        this.subtotal = parseFloat((initialSubtotal * (1 - this.couponValue / 100)).toFixed(3));
      } else {
        this.subtotal = initialSubtotal;
      }

      localStorage.setItem('subtotal', this.subtotal.toString());
      console.log("jjjjjjjjjjjjjjjjjj",this.subtotal.toString())
      this.cdr.detectChanges();
    }
    getTotalSubtotal(): number {
      return parseFloat(this.cartItems.reduce((total, item) => total + item.subtotal, 0).toFixed(2));
    }
}
